import Swiper from 'swiper';
import { Navigation, Autoplay } from 'swiper/modules';

const swiperConfig = {
    modules: [Navigation, Autoplay],
    slidesPerView: 1,
    navigation: {
        addIcons: false,
    },
};

document.addEventListener('DOMContentLoaded', () => {
    const headerSlider = document.querySelector('.header-slider .swiper');

    if (headerSlider) {
        const container = headerSlider.closest('.header-slider');
        const nextEl = container?.querySelector('.swiper-button-next');
        const prevEl = container?.querySelector('.swiper-button-prev');

        if (nextEl && prevEl) {
            new Swiper(headerSlider, {
                ...swiperConfig,
                navigation: {
                    ...swiperConfig.navigation,
                    nextEl,
                    prevEl,
                },
                autoplay: {
                    delay: 5000,
                },
            });
        }
    }

    const creditSliders = document.querySelectorAll('.widget-credit .swiper');

    creditSliders.forEach((creditSlider) => {
        const container = creditSlider.closest('.widget-credit');
        const nextEl = container?.querySelector('.swiper-button-next');
        const prevEl = container?.querySelector('.swiper-button-prev');

        if (!nextEl || !prevEl) {
            return;
        }

        new Swiper(creditSlider, {
            ...swiperConfig,
            navigation: {
                ...swiperConfig.navigation,
                nextEl,
                prevEl,
            },
        });
    });
});
